export default __webpack_public_path__ + "static/media/tt.a27db96a.svg";